
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/modules-and-containers",
      function () {
        return require("private-next-pages/design-system/modules-and-containers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/modules-and-containers"])
      });
    }
  